(async () => {

  function fetchConfig(type = 'json') {
    return {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', 'Accept': `application/${type}` }
    };
  }

  if (!customElements.get('product-quickshop')) {
    class ProductQuickshop extends HTMLElement {
      constructor() {
        super();

        this.defaultOptions = {};

        // Check if we have extra options on the HTML
        if (this.dataset && this.dataset.options) {
          const jsonOptions = JSON.parse(this.dataset.options);

          if (jsonOptions) {
            this.options = {
              ...this.defaultOptions,
              ...jsonOptions
            };
          }
        }

        this.quickshopDrawer = document.getElementById('quickshop-drawer');
        if (!this.quickshopDrawer) {
          return;
        }
        this.target = this.quickshopDrawer.querySelector('[data-quickshop-drawer]');

        // Catch click on quickshop button
        this.addEventListener('click', this.handleClick );

      }

      async handleClick() {

        // Close the drawer
        this.quickshopDrawer.close();

        try {

          // Get the product data
          let response = await fetch(`/products/${this.options.handle}?section_id=main-product`);

          // If the call failed, throw an error
          if (!response.ok) {
            throw 'Could not find product data.';
          }

          let content = await response.text();
          this.renderContents(content);

        } catch (error) {
          console.warn(error);
        }
      }

      // Render the html in the drawer
      renderContents(content){

        // Clear drawer html
        this.target.innerHTML = "";

        // Parse string in dom document
        const html = new DOMParser().parseFromString(content, 'text/html');

        // Extract
        const contentOutput = html.getElementById('shopify-section-main-product');

        // Add new html
        this.target.innerHTML = contentOutput.outerHTML;

        // Find rebuy widget placeholder from quickshop
        let rebuyWidget = document.getElementById('rebuy-quickshop-upsell-widget').cloneNode(true);
        let quickshopProductId = this.quickshopDrawer.querySelector('[data-quickshop-product-id]').dataset.quickshopProductId;
        let rebuyTarget = this.quickshopDrawer.querySelector('[data-product-info]');

        if(rebuyWidget && quickshopProductId && rebuyTarget){

          let rebuy_id = rebuyWidget.dataset.rebuyWidget;

          // Change element attributes
          rebuyWidget.removeAttribute('id');
          rebuyWidget.dataset.rebuyId = rebuy_id;
          rebuyWidget.dataset.rebuyShopifyProductIds = quickshopProductId;

          // Append widget html to quickshop result
          rebuyTarget.appendChild(rebuyWidget);

          // Init rebuy
          Rebuy.init();

          // Close quickshop drawer when Rebuy button is clicked
          rebuyTarget.addEventListener('click', (e) => {
            e.stopPropagation();
            if (e.target.classList.contains('rebuy-button')) {
              this.quickshopDrawer.close();
            }
          });
        }

        // Open the drawer
        this.quickshopDrawer.open();
      }

    }
    window.ProductQuickshop = ProductQuickshop;
    customElements.define('product-quickshop', ProductQuickshop);
  }


})();
